import React from 'react';

import cn from 'classnames';

import s from './mc.module.scss';

const PAD_CLASS = {
  none: s.cardPadNone,
  sm: s.cardPadSm,
  md: s.cardPadMd,
  lg: s.cardPadLg,
};

/**
 * MCCard — base surface: white bg, 1px hairline, radius var(--r-md).
 * Pure presentational. Padding is token-driven via the `pad` prop.
 *
 * @param {'none'|'sm'|'md'|'lg'} [pad='md']
 * @param {React.ElementType} [as='div']
 */
const MCCard = ({ as: Tag = 'div', pad = 'md', className, children, ...rest }) => (
  <Tag className={cn(s.card, PAD_CLASS[pad] || PAD_CLASS.md, className)} {...rest}>
    {children}
  </Tag>
);

export default MCCard;
